import { makeStyles } from "@mui/styles";
import { COLORS } from "../../../constant/colors";

const useStyles = makeStyles((theme) => ({
  footerSec: {
    paddingTop: 80,
    marginTop: 80,
    background: COLORS.secondary,
    paddingBottom: 20,
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "40px",
      backgroundImage: "url('/images/footer-wave.svg')",
      backgroundSize: "auto 100%",
      backgroundRepeat: "repeat-x",
      backgroundPosition: "top center",
      zIndex: 1,
    },
    "@media (max-width: 600px)": {
      paddingTop: 65,
      marginTop: 60,
      "&::before": {
        height: "30px",
      },
    },
  },
  playStoreSec: {
    borderBottom: `1px solid ${COLORS.white}`,
    paddingTop: 30,
    background: "#f0f0f0",
    marginBottom: 30,
    paddingBottom: 30,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "@media (max-width: 480px)": {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  downloadText: {
    textAlign: "center",
    color: COLORS.black,
    fontSize: 20,
    textTransform: "uppercase",
    fontWeight: "500",
    fontFamily: "Poppins",
    letterSpacing: 5,
    margin: 0,
    "@media (max-width: 768px)": {
      fontSize: 16,
    },
    "@media (max-width: 480px)": {
      marginLeft: 15,
      marginBottom: 15,
      letterSpacing: 2,
      fontSize: 14,
    },
  },
  playStoreLink: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    color: COLORS.black,
    fontWeight: "500",
    fontSize: 13,
    marginLeft: 20,
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      color: COLORS.primary,
      opacity: 0.8,
    },
  },
  playStoreLogo: {
    width: 70,
    height: "auto",
    marginBottom: 5,
    "@media (max-width: 768px)": {
      width: 50,
    },
  },
  footerMenuSec: {
    padding: "20px 0",
    position: "relative",
    zIndex: 2,
    marginTop: "20px",
    "@media (max-width: 600px)": {
      padding: "0px",
      marginTop: "10px",
    },
  },
  footerMenuTitle: {
    color: COLORS.white,
    textTransform: "uppercase",
    fontSize: "18px !important",
    fontWeight: "700",
    fontFamily: "Poppins, sans-serif",
    letterSpacing: 1.5,
    marginBottom: 25,
    position: "relative",
    "@media (max-width: 600px)": {
      fontSize: "16px !important",
      marginBottom: 15,
    },
  },
  footerMenuList: {
    paddingBottom: 8,
    listStyle: "none",
  },
  menuLink: {
    color: COLORS.white,
    opacity: 0.85,
    fontSize: "15px !important",
    fontWeight: "500",
    transition: "all 0.3s ease-in-out",
    padding: "8px 0",
    display: "block",
    position: "relative",
    "&:hover": {
      color: COLORS.cream,
      textDecoration: "none",
      transform: "translateX(5px)",
      opacity: 1,
    },
    "&::before": {
      content: '""',
      position: "absolute",
      left: "-15px",
      top: "50%",
      transform: "translateY(-50%)",
      width: "6px",
      height: "6px",
      borderRadius: "50%",
      background: COLORS.white,
      opacity: 0,
      transition: "all 0.3s ease-in-out",
    },
    "&:hover::before": {
      opacity: 1,
      left: "-12px",
    },
    "@media (max-width: 600px)": {
      fontSize: "14px !important",
      padding: "5px 0",
    },
  },
  footerSocialMenuTitle: {
    color: COLORS.white,
    textTransform: "uppercase",
    fontSize: "18px !important",
    fontWeight: "700",
    fontFamily: "Poppins, sans-serif",
    letterSpacing: 1.5,
    marginBottom: 25,
    textAlign: "end",
    position: "relative",
    "@media (max-width: 768px)": {
      textAlign: "left",
      "&::after": {
        right: "auto",
        left: 0,
      },
    },
    "@media (max-width: 600px)": {
      fontSize: "16px !important",
      marginBottom: 15,
    },
  },
  socialUl: {
    display: "flex",
    justifyContent: "end",
    marginBottom: 40,
    alignItems: "center",
    gap: "15px",
    "@media (max-width: 768px)": {
      justifyContent: "flex-start",
    },
  },
  socialLi: {
    marginLeft: 0,
  },
  socialLink: {
    width: 45,
    height: 45,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: COLORS.white,
    borderRadius: "50%",
    color: COLORS.secondary,
    transition: "all 0.3s ease-in-out",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
    border: "2px solid transparent",
    "&:hover": {
      transform: "translateY(-3px) scale(1.1)",
      color: COLORS.white,
      background: COLORS.primary,
      boxShadow: "0 8px 25px rgba(169, 37, 60, 0.3)",
      border: `2px solid ${COLORS.white}`,
    },
    "@media (max-width: 500px)": {
      width: 40,
      height: 40,
    },
  },
  socialPaymentUl: {
    marginTop: 0,
    flexWrap: "wrap",
  },
  // paymentPartnerLogo: {
  //   width: 50,
  //   height: "auto",
  //   marginBottom: 10
  // },
  paymentPartnerImgSec: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    maxWidth: "80%",
    marginLeft: "auto",
    "@media (max-width: 768px)": {
      marginLeft: "0px",
      maxWidth: "70%",
    },
  },
  paymentPartnerImg: {
    maxWidth: 280,
    marginBottom: 40,
    marginLeft: "auto",
  },
  copyrightSec: {
    textAlign: "center",
    paddingTop: 20,
    borderTop: "1px solid rgba(255, 255, 255, 0.2)",
    marginTop: "10px",
    position: "relative",
  },
  copyrightText: {
    color: COLORS.white,
    fontSize: 14,
    fontFamily: "Poppins, sans-serif",
    fontWeight: "500",
    lineHeight: "1.6",
  },
}));

export default useStyles;
